import type { EntityConfig } from '../types'

export const disputeEntity: EntityConfig = {
  id: 'dispute',
  displayName: 'Dispute',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'needs_response', label: 'Needs Response' },
      { value: 'under_review', label: 'Under Review' },
      { value: 'won', label: 'Won' },
      { value: 'lost', label: 'Lost' },
      { value: 'charge_refunded', label: 'Refunded' },
    ],
    options: [
      { value: 'warning_needs_response', label: 'Needs Response (Warning)', color: 'error' },
      { value: 'needs_response', label: 'Needs Response', color: 'warning' },
      { value: 'warning_under_review', label: 'Under Review (Warning)', color: 'error' },
      { value: 'under_review', label: 'Under Review', color: 'pending' },
      { value: 'charge_refunded', label: 'Dispute Refunded', color: 'info' },
      { value: 'won', label: 'Dispute Won', color: 'success' },
      { value: 'lost', label: 'Dispute Lost', color: 'error' },
      { value: 'warning_closed', label: 'Closed (Warning)', color: 'error' },
    ],
    mappings: {
      all: [],
      needs_response: ['warning_needs_response', 'needs_response'],
      under_review: ['warning_under_review', 'under_review'],
      won: ['won'],
      lost: ['lost'],
      charge_refunded: ['charge_refunded'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    amount: { type: 'amount', urlKey: 'amount' },
    reason: { type: 'string_array', urlKey: 'reason' },
    customerName: { type: 'search', urlKey: 'customerName' },
    paymentId: { type: 'search', urlKey: 'paymentId' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'amount',
    'dateRange',
  ]
}
